<div class="legal-information-modal">
  <header>
    <app-title-large>{{'TermsOfUse' | translate }}</app-title-large>
    <mat-icon (click)="close()">close</mat-icon>
  </header>

  <div mat-dialog-content="">
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>{{'LoadingContent' | translate}}</p>
    </div>

    <article *ngIf="!isLoading && content" class="wysiwyg-content" [innerHTML]="content">
    </article>

    <article *ngIf="!isLoading && !content">
      <p>{{'NoContentAvailable' | translate}}</p>
    </article>
  </div>
  <div mat-dialog-actions="">
    <button class="btn-close" (click)="close()">{{"Close" | translate}}</button>
  </div>
</div>